export const projects = [
  {
    id: 1,
    title: "BUILDRRR App",
    shortDescription: "A Multiple User application that helps users buy houses quickly through Home Developers and build houses from scratch.",
    description: "BUILDRRR is a Multiple User application that can help users to be able to buy houses quickly through Home Developers, besides that users can also build houses starting from 0 which can be accompanied by Architects & Builders, BUILDRRR is open for 5 users (Client, Developer, Marketing , Architect, Foreman).",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770140207/Preview_BUILDRRR_uddcfv.png",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770143144/buildrr1_znyuee.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770143144/budilr2_znlz7e.png"
    ],
    category: "Android",
    techStack: ["Kotlin", "Android Studio", "Firebase", "XML",  "Material Design"],
    keyFeatures: [
      "Real-time property listings with detailed information",
      "Direct connection with home developers",
      "Step-by-step guidance for building from scratch",
      "Construction progress tracking"
    ],
    github: "https://github.com/Zainul-Code/HOME-BUILDRRR-Apps",
    demo: "https://drive.google.com/file/d/15dgZg-M80u8pTEFiUPuUeFom2ZFbtbvz/view?usp=sharing"
  },
    {
    id: 2,
    title: "Automated Watering System",
    shortDescription: "Automated Watering System is an IoT-based automatic plant watering system that can be controlled via an Android application.",
    description: "This application is designed to assist users (gardeners) in managing plant watering to be more efficient, timely, and water-efficient. The system works by reading data from soil moisture sensors and air temperature & humidity sensors, then determining when the water pump should turn on, either automatically, on a schedule, or manually via the application.",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770140709/Preview_AWS_eeiohq.jpg",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770202040/Cover_e7wiou.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770202395/Cover_2_fmgec4.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770202039/Cover-2_u0datx.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770202039/Cover-3_pgrclw.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770202039/Cover-1_dbf0lf.jpg"
    ],
    category: "Android",
    techStack: ["Java", "Android Studio", "XML", "IoT", "Firebase"],
    keyFeatures: [
      "Automatic watering based on soil moisture",
      "Remote monitoring via app",
      "Watering schedule management",
      "Real-time notifications",
      "User Management"
    ],
    github: "https://github.com/zai-code-star/Automated-Watering-System-App",
    demo: "https://drive.google.com/file/d/1ALD7LCZ3URjEGL-j4zGuFJchDAJni__l/view"
  },
  {
    id: 3,
    title: "CenttyApp",
    shortDescription: "CenttyApp is a mobile application to make it easier search for properties from Central Property Purwokerto agents.",
    description: "CenttyApp is a mobile application designed to make it easier for users to search for properties and communicate directly with Central Property Purwokerto agents.",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142625/CenttyAppPreview_nha4mp.png",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142625/homeusercentty_ltcvzz.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142626/searchcentty_b8zrpc.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142626/userchatcentty_zvvj4l.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142625/userfavcentty_puu8z6.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770142625/userprofilecentty_ljz6uk.png"

    ],
    category: "Android",
    techStack: ["Kotlin", "Android Studio", "Firebase", "Sqlite", "XML", "Material Design" ],
    keyFeatures: [
      "Search Property with filter",
      "Chat menu for communicate directly",
      "Favorite Page to mark property"
    ],
    github: "https://github.com/zai-code-star/CenttyApp",
    demo: "https://drive.google.com/file/d/1qswYiPp03zV_Iq2O9bfPyvKrVRnksWCJ/view?usp=sharing"
  },
  {
    id: 4,
    title: "Fresh Laundry App",
    shortDescription: "FreshLaundry – Laundry Pickup and Delivery App.",
    description: "FreshLaundry is an Android app for laundry pick-up and delivery services that makes it easy for customers to place orders, schedule appointments, and track their status in real time. This app is also designed to help laundry operations run faster, smoother, and more efficiently.",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770140714/Preview_FreshLaundry_g5z24d.png",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770196019/Cover_2_qmpfng.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770196424/Cover_3_xjkn1w.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770197012/Cover_5_h6ga3q.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770197014/Cover_6_m2w5uf.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770197016/Cover_7_tdtj86.png"
    ],
    category: "Android",
    techStack: ["Kotlin", "Android Studio", "Firebase", "Sqlite", "XML","Material Design"],
    keyFeatures: [
      "Real-time Chat",
      "Integrated A-Star Algoritm",
      "Pickup and delivery scheduling",
      "Realtime Monitoring"
    ],
    github: "https://github.com/zai-code-star/FreshLaundry",
    demo: "https://drive.google.com/file/d/1EnAGuutx6ny9vrv4daoWonfO8RwJvMG8/view",
    demo: "https://drive.google.com/file/d/1UTPqvDqdEq12h5cAxYyKnEFl_5bXkfAz/view"
  },
  {
    id: 5,
    title: "Multi Agent System",
    shortDescription: "Online Gambling Comment Classification using Multi-Agent ML System.",
    description: "This project implements a multi-agent system based on LLMs (GPT API) to build a text classification pipeline, specifically for online gambling comments. The system uses vertical collaboration among agents: 1. Recruiter Agent – Selects the most relevant agents for a specific task. 2. Pipeline Designer Agent – Designs and improvises the ML pipeline based on goals and evaluator feedback. 3. ML Engineer Agent – Implements the pipeline, generates Python code, executes it, and handles errors adaptively. 4. Evaluator Agent – Evaluates the pipeline using standard classification metrics (Accuracy, F1 Score, Precision, Recall) and provides feedback for iterative improvements. 5. Orchestrator – Manages the workflow and iteration between agents and stops the process once the success criteria are met.",
    image: "https://cdn.sanity.io/images/7m9jw85w/production/8de93915700c90d8442f4342edb3d9cdb5ef0266-720x402.png?w=720",
    images: [
    ],
    category: "Machine Learning",
    techStack: ["Python", "PyCharm", "OpenAI API", "PyCharm", "Pandas", "NumPy", "Scikit-learn"],
    keyFeatures: [
      "Multi-agent coordination",
      "Reinforcement learning",
      "Collaborative decision making",
      "Real-time logs agent communication",
      "Model Ready to Use"
    ],
    github: "https://github.com/zai-code-star/multi_agent",
    demo: null
  },
    {
    id: 6,
    title: "Peternakan App",
    shortDescription: "Livestock management application for farmers.",
    description: "Peternakan App is a mobile application designed to assist in the digital management of livestock businesses. This application facilitates the recording of animal data, feed stocks, sales, and transaction histories in a single system that is simple and easy to use.",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199592/Cover_1_pfswqo.jpg",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199608/Cover_yefcrs.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199609/Cover-1_xopis5.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199608/Cover-3_l53lhg.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199608/Cover-2_bv792v.jpg",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770199606/Cover-4_ulyklb.jpg"
    ],
    category: "Android",
    techStack: ["Kotlin", "Android Studio", "XML", "Material Design"],
    keyFeatures: [
      "Animal Stock tracking",
      "Sale management",
      "Feed tracking"
    ],
    github: "https://github.com/zai-code-star/PeternakanApp",
    demo: null
  },
  {
    id: 7,
    title: "Deteksi Ritme Musik",
    shortDescription: "Music rhythm detection using deep learning.",
    description: "Music Rhythm Detection is a Python-based project used to analyse and detect music rhythm patterns by utilising audio signal processing and a Deep Learning approach.",
    image: "https://github.com/zai-code-star/Deteksi-Ritme-Musik/raw/main/assets/screenshots/Preview.jpeg",
    images: [
      "https://github.com/zai-code-star/Deteksi-Ritme-Musik/raw/main/assets/screenshots/Hasil.jpeg",
      "https://github.com/zai-code-star/Deteksi-Ritme-Musik/raw/main/assets/screenshots/Terminal.jpeg"
    ],
    category: "Machine Learning",
    techStack: ["Python", "PureBasic",  "Audio Processing"],
    keyFeatures: [
      "Beat detection and tracking",
      "Rhythm pattern",
      "Genre identification"
    ],
    github: "https://github.com/zai-code-star/Deteksi-Ritme-Musik",
    demo: null
  },
  {
    id: 8,
    title: "Klasifikasi Komentar Judi Online",
    shortDescription: "Text classification for detecting gambling promotions.",
    description: "An NLP-based classification system designed to detect online gambling promotional content in TikTok comments.",
    image: "https://www.techfor.id/wp-content/uploads/2021/08/Picture1-6.png",
    images: [
    ],
    category: "Machine Learning",
    techStack: ["Python", "Scikit-learn", "Pandas", "NumPy", "Matplotlib", "Jupyter Notebook"],
    keyFeatures: [
      "Text preprocessing",
      "Feature extraction (TF-IDF with N-Gram)",
      "Multiple ML classifiers",
      "Console Realtime Prediction"
    ],
    github: "https://github.com/zai-code-star/Klasifikasi-Komentar-Teks-Promosi-Judol",
    demo: "https://repository.telkomuniversity.ac.id/pustaka/244762/klasifikasi-komentar-teks-promosi-judi-online-pada-media-sosial-tiktok-menggunakan-machine-learning-dalam-bentuk-buku-karya-ilmiah.html"
  },
  {
    id: 9,
    title: "Analisis Sentimen PLN Mobile",
    shortDescription: "Sentiment analysis of PLN Mobile app reviews.",
    description: "A comprehensive sentiment analysis project that examines user reviews of the PLN Mobile application.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi5HGSzft0XDVckAxCQxQ8YZKhPUo0Mu117w&s",
    images: [
    ],
    category: "Machine Learning",
    techStack: ["Python", "Scikit-learn", "Pandas", "NumPy", "Matplotlib", "Jupyter Notebook"],
    keyFeatures: [
      "Sentiment classification",
      "Key issue identification"
    ],
    github: "https://github.com/zai-code-star/Analisis_Sentimen_Ulasan_PLN_Mobile",
    demo: null
  },
    {
    id: 10,
    title: "Medich App",
    shortDescription: "Healthcare application addressing BPJS satisfaction issues with donation features.",
    description: "Medich is an application that raises the problem of satisfaction related to BPJS, especially in the lower classes, with Medich being able to solve all these problems. Medich has a Donation feature that will be very useful for the Community.",
    image: "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770215870/meddich1_rhvxwp.png",
    images: [
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770215870/meddich1_rhvxwp.png",
      "https://res.cloudinary.com/dpmt6w1wv/image/upload/v1770215871/meddich_b7r9ho.png"
    ],
    category: "Android",
    techStack: ["Kotlin", "Android Studio", "XML",  "SQLite"],
    keyFeatures: [
      "Healthcare donation system",
      "Telemedicine consultations",
      "Medicine delivery service",
      "Health records management",
      "Hospital and clinic finder"
    ],
    github: "https://github.com/Zainul-Code/Medich-App",
    demo: null
  }
];
